var exports = {
  "k": "x43aef4ae--c99dc2--container",
};

module.exports = exports;
